import { Component, HostListener } from '@angular/core'
import { Subscription } from 'rxjs'
import { CookieService } from 'src/app/services/cookie/cookie.service'

import { environment } from '../../../environments/environment'
import { FundLiterature, LiteratureData } from './fund-literature.model'
import { FundLiteratureService } from './fund-literature.service'

@Component({
  selector: 'fund-literature',
  templateUrl: './fund-literature.component.html',
  styleUrls: ['./fund-literature.component.scss'],
})
export class FundLiteratureComponent {
  fundLiteratureModel: FundLiterature
  stringModel: string
  fundLiteratureSubscription: Subscription
  breakTimeout: any
  isMasterSel: boolean
  totalSelectedfile = 0
  lastClickedBox: string
  literatureLink: string
  selectedPdfs: any = []
  showDownloadButton = true
  innerWidth: number
  literatureModel: LiteratureData[] = []
  id = 0
  pdfLink = environment.literaturePrefix

  @HostListener('document:click', [])
  onDocumentClick() {
    this.lastClickedBox = ''
  }
  constructor(
    private readonly fundLiteratureService: FundLiteratureService,
    private readonly cookieService: CookieService,
  ) {
    this.isMasterSel = false
  }
  ngOnInit() {
    this.innerWidth = window.innerWidth
    this.fundLiteratureSubscription = this.fundLiteratureService
      .getModelData()
      .subscribe((model) => {
        this.fundLiteratureModel = model
        this.setLiteratureLink()
      })
  }

  checkUncheckAll(flag) {
    if (flag) {
      this.isDownloadingPdfs()
      this.totalSelectedfile = this.literatureModel.length
      this.lastClickedBox = ''

      for (const item of this.literatureModel) {
        item.isSelected = this.isMasterSel
        this.selectedPdfs.push({
          url: item.pdfPath,
          name: item.literatureName,
        })
      }
    } else {
      this.selectedPdfs = []
      this.totalSelectedfile = 0
      this.lastClickedBox = 'all'
      for (const item of this.literatureModel) {
        item.isSelected = this.isMasterSel
      }
    }
  }

  isDownloadingPdfs() {
    if (this.breakTimeout) {
      this.showDownloadButton = true
      this.totalSelectedfile = 0
      this.selectedPdfs = []
      clearTimeout(this.breakTimeout)
      this.breakTimeout = undefined
    } else {
      return
    }
  }

  isAllSelected(item) {
    if (item.isSelected) {
      this.isDownloadingPdfs()
      this.isMasterSel = false
      this.totalSelectedfile = this.totalSelectedfile + 1
      this.lastClickedBox = ''
      this.selectedPdfs.push({ url: item.pdfPath, name: item.literatureName })
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      this.isMasterSel =
        this.totalSelectedfile === this.literatureModel.length ? true : false
    } else {
      this.totalSelectedfile = this.totalSelectedfile - 1
      const itemIndex = this.selectedPdfs.findIndex(
        (x) => x.url === item.pdfPath,
      )
      this.selectedPdfs.splice(itemIndex, 1)
      this.isMasterSel = false
      this.lastClickedBox = item.literatureName
    }
  }
  setLiteratureLink() {
    this.cookieService.isInternalSession().subscribe((response) => {
      if (response === 'true') {
        this.literatureLink = environment.internalUrl.concat(
          'ngf-next-gen-form-webapp/fund-literatures/',
        )
      } else {
        this.literatureLink = environment.newExternalUrl.concat(
          'usa/ngf-next-gen-form-webapp/public/fund-literatures/',
        )
      }
    })
  }

  isValidTypeCode(typeCode) {
    const types = ['SP', 'PR', 'SA', 'PB', 'AR']
    return types.includes(typeCode)
  }
  getLiteratureData(model) {
    for (const element in model) {
      if (model[element].fundIds) {
        model[element].fundIds.forEach((ele) => {
          if (
            ele === this.fundLiteratureModel.fundId &&
            this.isValidTypeCode(model[element].formLitTypeCode)
          ) {
            this.id = this.id + 1
            this.literatureModel.push({
              formLitTypeCode: model[element].formLitTypeCode,
              pdfPath: this.pdfLink + model[element].pdfPath,
              literatureId: model[element].literatureId,
              formAsOfDate: model[element].formAsOfDate,
              isSelected: false,
              id: this.id,
              literatureName: this.setLiteratureName(
                model[element].formLitTypeCode,
              ),
            })
          }
        })
      } else {
        continue
      }
    }
  }
  /*eslint complexity: [2, 30] */
  setLiteratureName(typeCode: string) {
    let type
    switch (typeCode) {
      case 'SP':
        type = 'Summary Prospectus'
        break
      case 'PR':
        type = 'Statutory Prospectus'
        break
      case 'PB':
        type = 'Statement of Additional Information'
        break
      case 'SA':
        type = 'Semiannual Report'
        break
      case 'AR':
        type = 'Annual Report'
        break
    }
    return type
  }
  download(arrayBuffer: any, fileName: string): void {
    const blobUrl = 'data:application/pdf;base64,' + arrayBuffer

    const anchorElement: HTMLAnchorElement = document.createElement('a')
    anchorElement.download = fileName
    anchorElement.href = blobUrl
    anchorElement.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      }),
    )
  }
  doc_download() {
    this.literatureModel.forEach((element) => {
      element.isSelected = false
    })
    this.isMasterSel = false
    for (let i = 0; i < this.selectedPdfs.length; i++) {
      this.fundLiteratureService
        .downloadPdf(this.selectedPdfs[i].url, this.fundLiteratureModel?.fundId)
        .subscribe((response: any) =>
          this.download(response, this.selectedPdfs[i].name),
        )

      if (i === this.selectedPdfs.length - 1) {
        this.showDownloadButton = false
        this.displayDownloadMessage()
      } else {
        this.showDownloadButton = true
      }
    }
  }
  displayDownloadMessage() {
    this.breakTimeout = setTimeout(() => {
      this.totalSelectedfile = 0
      this.selectedPdfs = []
      this.showDownloadButton = true
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 3000)
  }

  getBorderColor() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (this.innerWidth <= 576) {
      return '#1a1a1a'
    } else {
      return '#d1d1d1'
    }
  }

  detectScreenSize() {
    this.innerWidth = window.innerWidth
  }
}
